import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_TAX, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * LineItemTaxMaybe
 *
 * Displays the tax line item in the order breakdown if present.
 * Tax is calculated by Avalara AvaTax and added to the transaction
 * when the buyer's shipping address is in a registered tax jurisdiction.
 */
const LineItemTaxMaybe = props => {
  const { lineItems, intl } = props;

  // Find the tax line item (not a reversal/refund)
  const taxLineItem = lineItems.find(
    item => item.code === LINE_ITEM_TAX && !item.reversal
  );

  // Find any tax refund line item
  const taxRefundLineItem = lineItems.find(
    item => item.code === LINE_ITEM_TAX && item.reversal
  );

  // If there's no tax line item, don't render anything
  if (!taxLineItem && !taxRefundLineItem) {
    return null;
  }

  return (
    <>
      {taxLineItem ? (
        <div className={css.lineItem}>
          <span className={css.itemLabel}>
            <FormattedMessage id="OrderBreakdown.tax" />
          </span>
          <span className={css.itemValue}>
            {formatMoney(intl, taxLineItem.lineTotal)}
          </span>
        </div>
      ) : null}
      {taxRefundLineItem ? (
        <div className={css.lineItem}>
          <span className={css.itemLabel}>
            <FormattedMessage id="OrderBreakdown.taxRefund" />
          </span>
          <span className={css.itemValue}>
            {formatMoney(intl, taxRefundLineItem.lineTotal)}
          </span>
        </div>
      ) : null}
    </>
  );
};

LineItemTaxMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTaxMaybe;
